import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  const cols = [
    { title: "Shop", links: [
      { label: "T-Shirts", to: "/t-shirts" },
      { label: "Polos", to: "/polos" },
      { label: "Hoodies & Sweatshirts", to: "/hoodies-sweatshirts" },
      { label: "Cups & Drinkware", to: "/cups" },
      { label: "Custom Boxes", to: "/custom-boxes" },
    ] },
    { title: "Design", links: [
      { label: "Custom Design", to: "/custom-design" },
      { label: "Group Orders", to: "/group-orders" },
      { label: "Business Printing", to: "/business-printing" },
      { label: "Personalized Gifts", to: "/gifts" },
      { label: "How It Works", to: "/how-it-works" },
    ] },
    { title: "Company", links: [
      { label: "Our Story", to: "/about" },
      { label: "Blog", to: "/blog" },
      { label: "Our Work", to: "/our-work" },
      { label: "Contact", to: "/contact" },
    ] },
  ];
  return (
    <footer className="bg-[color:var(--dms-navy-dark)] text-white/80">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-[#f5efe4] flex items-center justify-center">
              <span className="font-serif italic text-[color:var(--dms-navy)] text-[15px]">DMS</span>
            </div>
            <span className="font-serif italic text-white text-[22px]">Design My Story</span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60">Faith-inspired apparel, mugs and gift boxes — each one designed with prayer.</p>
          <div className="mt-6 flex items-center gap-4">
            <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[color:var(--dms-peach)] hover:text-[color:var(--dms-navy)] hover:border-transparent transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[color:var(--dms-peach)] hover:text-[color:var(--dms-navy)] hover:border-transparent transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[color:var(--dms-peach)] hover:text-[color:var(--dms-navy)] hover:border-transparent transition-colors"><Mail className="w-4 h-4" /></a>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="text-white font-semibold tracking-wider uppercase text-xs">{c.title}</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {c.links.map((l) => (
                <li key={l.label}><Link to={l.to} className="hover:text-[color:var(--dms-peach)] transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between text-sm text-white/55">
          <p>© {new Date().getFullYear()} Design My Story. All rights reserved.</p>
          <p className="font-serif italic text-[color:var(--dms-peach)]">Life is full of stories — Jesus is designing yours.</p>
        </div>
      </div>
    </footer>
  );
}
